/**
 * The permissions a GoHighLevel private integration needs here, every one
 * view-only, by GoHighLevel's own name for it (what its permission picker shows
 * and can be searched by) beside what is read with it.
 *
 * In step with the reads in `api/src/services/ghl-client.service.ts`: a read
 * added there needs its permission here, or a key made from this list fails it.
 */
const PERMISSIONS = [
  { scope: 'locations.readonly', reads: 'the sub-account’s name and time zone' },
  { scope: 'contacts.readonly', reads: 'each couple’s name, email, phone and details' },
  { scope: 'locations/customFields.readonly', reads: 'the contact fields copied into events' },
  { scope: 'opportunities.readonly', reads: 'leads and their pipeline stages' },
  { scope: 'calendars.readonly', reads: 'the calendars tours are booked on' },
  { scope: 'calendars/events.readonly', reads: 'booked tours, for lead stats' },
] as const

/**
 * The list under a key field. Its own block rather than the field's hint, so it
 * stays in view when the form shows an error — a key short a permission is
 * exactly when somebody needs it.
 */
export function GhlKeyPermissions() {
  return (
    <div className="text-small text-ink-muted">
      <p className="m-0">The private integration needs these permissions, all view only:</p>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {PERMISSIONS.map((p) => (
          <li key={p.scope}>
            <code className="font-mono text-xs text-ink">{p.scope}</code> — {p.reads}
          </li>
        ))}
      </ul>
    </div>
  )
}
